import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import styled from 'styled-components';
import Header from './components/Header';
import Footer from './components/Footer';
import CheckIn from './components/CheckIn';
import GoogleWallet from './components/GoogleWallet';
import AppleWallet from './components/AppleWallet';
import './styles.css';

const AppContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const MainContent = styled.main`
  flex: 1;
  padding: 1rem;
`;

const NotFound = () => (
  <div style={{ textAlign: 'center', padding: '2rem' }}>
    <h1>404 - ไม่พบหน้าที่คุณต้องการ</h1>
    <p>ขออภัย เราไม่พบหน้าที่คุณกำลังค้นหา</p>
  </div>
);

function App() {
  return (
    <Router>
      <AppContainer>
        <Header />
        <MainContent>
          <Routes>
            <Route path="/check-in/:userId" element={<CheckIn />} />
            <Route path="/wallet/google/:userId" element={<GoogleWallet />} />
            <Route path="/wallet/apple/:userId" element={<AppleWallet />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </MainContent>
        <Footer />
      </AppContainer>
    </Router>
  );
}

export default App;
